import './MainContentAreaAll.css';
import { Link } from 'react-router-dom';
function SynechronJobComponent(props){ 
    return(
       <div className="ExperienceMainLayout">   
       <br /> 
        <div class="card">
           <div class="card-footer" style={{height:"50px"}}>
            <span className="ExperienceCardFooter-Previous"><Link onClick={() => props.handlechange('Mphasis')}>Previous</Link></span>
            <span className="ExperienceCardFooter"><Link onClick={() => props.handlechange('AtT')}>Next</Link></span>
           </div>
           <h5 class="card-header">Synechron Charlotte NC	
                              <br/>Jan 2020 – Apr 2020
                              <br/>Full Stack.Net Developer
           </h5>    					       
           <div class="card-body">
           <h3 style={{textDecoration:"underline"}}>Roles And Responsibilities</h3>
            -Works on the New website which is visible to the users and simple users interface so people can understand the work process in financial sectors.<br/>
            -Use the latest version of angular 8 to create a simple single page application <br/>
            -Works closely with the With client and other team members to understand business needs and do Business Analysts in requirement gathering and design review activities.<br/>
            -Works closely with the EQA team to ensure the Quality of the Delivery.<br/>
            -Works on the MVC web API for maintaining the back end logic of single page application <br/>
            -Maintaining the old website and doing rework to change some layout in application which is developed using classic ASP.Net pages. and also create a API for older project <br/>
            -Involving in CICD flow for every day work and planning for new task <br/>
            -Querying SQL data queries, also used linq to generate data friendly query Stored Procedures and the views.<br/>
            -Working with the technologies like C#, jQuery and Web API Angular 8 <br/>
            -Working on the Database servers and generate a database for new application <br/>
            -Also Used a Visio and Make Data Model for New Upcoming UI <br/>
            -Also used  to create TSql Statement For Data Operation ,create T-SQL stored procedure ,Query and view for data operation for application <br/>
            -Create a data Model and Database <br/>
            -Create a Responsive UI Using Angular Material Io <br/>
            -Widely Used Angular Material Io <br/>
            -Used to work on task assigned on Jira Dashboard and Update the Workflow Daily Basics <br/>
            -Participating in daily scrums and helps following the Agile process.<br/>
            -Working with Git/github as the source for version control and project / issue management.<br/>
            -Create Api For Web Application Using Net Core 3.0 And Also work On Unit test Cases <br/>
            -Created Class Library Project For existingApplication Also Implement Infrastructure Layer Of Api Project<br/>
            -Work with azure to deploy Web api and also work with azure web app to deploy angular app <br/>
            -Also involved   in managing configuration of  load balancer to   control incoming traffic to application<br/>
            <h3 style={{textDecoration:"underline"}}>Environment</h3>
            Microsoft Visual Studio 2017, ASP.NET, C#, JSON, Agile and Scrum,GIT, AJAX, CSHTML, CSS,  SQL Server 2017, Windows Server 2010 ,Angular Cli,Angular,Angular Material
           </div>            
         </div>
       </div>
       
)
}
export default SynechronJobComponent